<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="轮播图" prop="bannerUsl">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.bannerUsl" :showUploadList="false"
          :customRequest="handleChange">
          <img v-if="form.bannerUsl" :src="form.bannerUsl" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="英文轮播图" prop="bannerUslEn">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.bannerUslEn" :showUploadList="false"
          :customRequest="handleChangeEn">
          <img v-if="form.bannerUslEn" :src="form.bannerUslEn" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="日语轮播图" prop="bannerUslJa">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.bannerUslJa" :showUploadList="false"
          :customRequest="handleChangeJa">
          <img v-if="form.bannerUslJa" :src="form.bannerUslJa" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingJa ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="印尼轮播图" prop="bannerUslId">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.bannerUslId" :showUploadList="false"
          :customRequest="handleChangeId">
          <img v-if="form.bannerUslId" :src="form.bannerUslId" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingId ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="葡语轮播图" prop="bannerUslPt">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.bannerUslPt" :showUploadList="false"
          :customRequest="handleChangePt">
          <img v-if="form.bannerUslPt" :src="form.bannerUslPt" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingPt ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="西语轮播图" prop="bannerUslEs">
        <a-upload listType="picture-card" class="avatar-uploader" v-model="form.bannerUslEs" :showUploadList="false"
          :customRequest="handleChangeEs">
          <img v-if="form.bannerUslEs" :src="form.bannerUslEs" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoadingEs ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="视频" prop="videoUrl">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrl"
          :showUploadList="false" :customRequest="handleVideo">
          <div v-if="videoUrl">
            <video :src="videoUrl" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadSize != 0"
          :percent=this.uploadSize />
      </a-form-model-item>


      <a-form-model-item label="英文视频" prop="videoUrlEn">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrlEn"
          :showUploadList="false" :customRequest="handleVideoEn">
          <div v-if="videoUrlEn">
            <video :src="videoUrlEn" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadEnSize != 0"
          :percent=this.uploadEnSize />
      </a-form-model-item>

      <a-form-model-item label="日语视频" prop="videoUrlJa">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrlJa"
          :showUploadList="false" :customRequest="handleVideoJa">
          <div v-if="videoUrlJa">
            <video :src="videoUrlJa" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingJa ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadJaSize != 0"
          :percent=this.uploadJaSize />
      </a-form-model-item>

      <a-form-model-item label="印尼视频" prop="videoUrlId">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrlId"
          :showUploadList="false" :customRequest="handleVideoId">
          <div v-if="videoUrlId">
            <video :src="videoUrlId" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingId ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadIdSize != 0"
          :percent=this.uploadIdSize />
      </a-form-model-item>

      <a-form-model-item label="葡语视频" prop="videoUrlPt">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrlPt"
          :showUploadList="false" :customRequest="handleVideoPt">
          <div v-if="videoUrlPt">
            <video :src="videoUrlPt" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingPt ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadPtSize != 0"
          :percent=this.uploadPtSize />
      </a-form-model-item>

      <a-form-model-item label="西语视频" prop="videoUrlEs">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrlEs"
          :showUploadList="false" :customRequest="handleVideoEs">
          <div v-if="videoUrlEs">
            <video :src="videoUrlEs" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingEs ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadEsSize != 0"
          :percent=this.uploadEsSize />
      </a-form-model-item>

      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="所属" prop="bannerType">
        <a-select placeholder="请选择" v-model="form.bannerType">
          <a-select-option :key="0">APP</a-select-option>
          <a-select-option :key="1">PC</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="imgType">
        <a-select placeholder="请选择" v-model="form.imgType">
          <a-select-option :key="0">轮播图</a-select-option>
          <a-select-option :key="1">广告图</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="跳转类型" prop="type">
        <a-select placeholder="请选择跳转类型" @change="updateType" v-model="form.type">
          <a-select-option :key="0">短剧</a-select-option>
          <a-select-option :key="1">外部链接</a-select-option>
          <a-select-option :key="2">充值页面</a-select-option>
          <a-select-option :key="3">签到</a-select-option>
          <a-select-option :key="4">会员充值页面</a-select-option>
          <a-select-option :key="5">内链</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="上架时间" prop="startTime">
        <a-date-picker :allow-clear="true" size="default" v-model="form.startTime" placeholder="开始时间"
          value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="下架时间" prop="endTime">
        <a-date-picker :allow-clear="true" size="default" v-model="form.endTime" placeholder="截止时间"
          value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
        </a-date-picker>
      </a-form-model-item>
      <a-form-model-item v-if="this.type == 0" label="是否跳转" prop="isJump">
        <a-select placeholder="请选择是否跳转" @change="updateIsGo" v-model="form.isJump">
          <a-select-option :key="false">否</a-select-option>
          <a-select-option :key="true">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type == 1 || this.type == 5" label="链接" prop="linkUrl">
        <a-input v-model="form.linkUrl" placeholder="请输入链接" />
      </a-form-model-item>
      <a-form-model-item v-if="this.isJup && this.type == 0" label="短剧（中文）" prop="videoId">
        <a-select v-model="form.videoId" showSearch style="width: 100%" placeholder="请选择短剧" allow-clear
          optionFilterProp="children">
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item, index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 英文短剧 -->
      <a-form-model-item v-if="this.isJup && this.type == 0" label="短剧（英文）" prop="videoIdEn">
        <a-select v-model="form.videoIdEn" showSearch style="width: 100%" placeholder="请选择英文短剧" allow-clear
          optionFilterProp="children">
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item, index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 日文短剧 -->
      <a-form-model-item v-if="this.isJup && this.type == 0" label="短剧（日文）" prop="videoIdJa">
        <a-select v-model="form.videoIdJa" showSearch style="width: 100%" placeholder="请选择日文短剧" allow-clear
          optionFilterProp="children">
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item, index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="this.isJup && this.type == 0" label="短剧（印尼）" prop="videoIdId">
        <a-select v-model="form.videoIdId" showSearch style="width: 100%" placeholder="请选择印尼短剧" allow-clear
          optionFilterProp="children">
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item, index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="this.isJup && this.type == 0" label="短剧（葡语）" prop="videoIdPt">
        <a-select v-model="form.videoIdPt" showSearch style="width: 100%" placeholder="请选择葡语短剧" allow-clear
          optionFilterProp="children">
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item, index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="this.isJup && this.type == 0" label="短剧（西语）" prop="videoIdEs">
        <a-select v-model="form.videoIdEs" showSearch style="width: 100%" placeholder="请选择西语短剧" allow-clear
          optionFilterProp="children">
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item, index) in listAll">
            {{ item.videoName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>


      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner } from '@/api/banner/banner'
import { listVideo } from "@/api/video/video";
import UploadFileToVOD from "@/api/vod.js"

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      uploadLoadingEn: false,
      uploadLoadingJa: false,

      uploadLoadingId: false,
      uploadLoadingPt: false,
      uploadLoadingEs: false,

      process: false,
      formTitle: '',
      videoUrl: '',
      videoUrlEn: '',
      videoUrlJa: '',

      videoUrlId: '',
      videoUrlPt: '',
      videoUrlEs: '',

      uploadSize: 0,
      uploadEnSize: 0,
      uploadJaSize: 0,

      uploadIdSize: 0,
      uploadPtSize: 0,
      uploadEsSize: 0,

      fileList: [],
      type: 0,
      listAll: [],
      isJup: false,
      // 表单参数
      form: {
        id: null,

        sort: null,

        videoId: null,

        videoIdJa: null,

        videoIdEn: null,

        videoIdId: null,

        videoIdPt: null,

        videoIdEs: null,

        isJump: false,
        linkUrl: null,
        videoUrl: null,
        videoUrlEn: null,
        videoUrlJa: null,
        startTime: null,
        endTime: null,
        videoUrlId: null,
        videoUrlPt: null,
        videoUrlEs: null,

        bannerType: null,
        imgType: null,
        type: null,

        bannerUsl: null,
        bannerUslEn: null,
        bannerUslJa: null,

        bannerUslId: null,
        bannerUslPt: null,
        bannerUslEs: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        sort: [
          { required: true, message: '排序不能为空' }
        ],
        isJump: [
          { required: true, message: '是否跳转不能为空' }
        ],
        linkUrl: [
          { required: true, message: '外部链接不能为空' }
        ],
        bannerUsl: [
          { required: true, message: '轮播图url不能为空' }
        ]
      }
    }
  },
  filters: {},
  created() {
    this.getGather();
    this.uploadSize = 0
    this.uploadEnSize = 0
    this.uploadJaSize = 0
    this.uploadIdSize = 0
    this.uploadPtSize = 0
    this.uploadEsSize = 0
  },
  computed: {},
  watch: {},
  mounted() {
  },

  methods: {
    handleChange(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.bannerUsl = fileName[0];//文件名
          console.log(11111111111111111)
          console.log(this.form.bannerUsl)
          that.uploadLoading = false;
        }
      });
      that.uploadLoading = false;
    },

    handleChangeEn(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.bannerUslEn = fileName[0];//文件名
          that.uploadLoadingEn = false;
        }
      });
      that.uploadLoadingEn = false;
    },

    handleChangeJa(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.bannerUslJa = fileName[0];//文件名
          that.uploadLoadingJa = false;
        }
      });
      that.uploadLoadingJa = false;
    },

    handleChangeId(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.bannerUslId = fileName[0];//文件名
          that.uploadLoadingId = false;
        }
      });
      that.uploadLoadingId = false;
    },

    handleChangePt(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.bannerUslPt = fileName[0];//文件名
          that.uploadLoadingPt = false;
        }
      });
      that.uploadLoadingPt = false;
    },

    handleChangeEs(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          console.log(fileName)
          that.form.bannerUslEs = fileName[0];//文件名
          that.uploadLoadingEs = false;
        }
      });
      that.uploadLoadingEs = false;
    },

    handleVideo(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      let that = this

      that.videoUrl = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.videoUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },
        vProgress: function (val) {
          that.uploadSize = val * 100;
        }
      });
      that.uploadLoading = false;

    },

    handleVideoEn(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingEn = true;
        return;
      }
      let that = this

      that.videoUrlEn = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.videoUrlEn = fileName[0];//文件名
          that.uploadLoadingEn = false;
        },
        vProgress: function (val) {
          that.uploadEnSize = val * 100;
        }
      });
      that.uploadLoadingEn = false;

    },


    handleVideoJa(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingJa = true;
        return;
      }
      let that = this

      that.videoUrlJa = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.videoUrlJa = fileName[0];//文件名
          that.uploadLoadingJa = false;
        },
        vProgress: function (val) {
          that.uploadJaSize = val * 100;
        }
      });
      that.uploadLoadingJa = false;

    },


    handleVideoId(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingId = true;
        return;
      }
      let that = this

      that.videoUrlId = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.videoUrlId = fileName[0];//文件名
          that.uploadLoadingId = false;
        },
        vProgress: function (val) {
          that.uploadIdSize = val * 100;
        }
      });
      that.uploadLoadingId = false;

    },
    handleVideoPt(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingPt = true;
        return;
      }
      let that = this

      that.videoUrlPt = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.videoUrlPt = fileName[0];//文件名
          that.uploadLoadingPt = false;
        },
        vProgress: function (val) {
          that.uploadPtSize = val * 100;
        }
      });
      that.uploadLoadingPt = false;

    },
    handleVideoEs(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingEs = true;
        return;
      }
      let that = this

      that.videoUrlEs = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          that.videoUrlEs = fileName[0];//文件名
          that.uploadLoadingEs = false;
        },
        vProgress: function (val) {
          that.uploadEsSize = val * 100;
        }
      });
      that.uploadLoadingEs = false;

    },

    updateType(value) {
      this.type = value
    },
    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading = false
        return false;
      }
      //TODO 驗證文件大小
    },
    updateIsGo(value) {
      this.isJup = value
    },
    onClose() {
      this.isJup = false
      this.uploadSize = 0
      this.uploadEnSize = 0
      this.uplaodJaSize = 0

      this.uplaodIdSize = 0
      this.uplaodPtSize = 0
      this.uplaodEsSize = 0
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    getGather() {
      listVideo({ isRelease: 1 }).then(res => {
        this.listAll = res.data;
      })
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.videoUrl = '',
        this.videoUrlEn = null,
        this.videoUrlJa = null,
        this.videoUrlId = null,
        this.videoUrlPt = null,
        this.videoUrlEs = null,
        this.bannerUsl = null,
        this.bannerUslEn = null,
        this.bannerUslJa = null,
        this.bannerUslId = null,
        this.bannerUslPt = null,
        this.bannerUslEs = null,
        this.videoId = null,
        this.videoIdId = null,
        this.videoIdPt = null,
        this.videoIdEs = null,
        this.startTime = null,
        this.endTime = null,
        this.uploadSize = 0,
        this.uploadEnSize = 0,
        this.uploadJaSize = 0,
        this.uploadIdSize = 0,
        this.uploadPtSize = 0,
        this.uploadEsSize = 0,
        this.form = {
          id: null,
          sort: null,
          videoId: null,
          isJump: null,
          bannerUsl: null,
          startTime: null,
          endTime: null,
          createTime: null,
          remark: null,
        }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({ "id": id }).then(response => {
        this.form = response.data
        this.videoUrl = this.form.videoUrl
        this.videoUrlEn = this.form.videoUrlEn
        this.videoUrlJa = this.form.videoUrlJa
        this.isJup = this.form.isJump
        this.type = this.form.type
        var fal = 0;
        for (var element of this.listAll) {
          if (element.id === this.form.videoId) {
            fal = 1
          }
        }
        if (fal == 0) {
          this.form.videoId = ''
        }
        this.open = true
        this.formTitle = '修改'
      })


    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        // 把多语言视频 URL 都赋值
        this.form.videoUrl = this.videoUrl
        this.form.videoUrlEn = this.videoUrlEn
        this.form.videoUrlJa = this.videoUrlJa
        this.form.videoUrlId = this.videoUrlId
        this.form.videoUrlPt = this.videoUrlPt
        this.form.videoUrlEs = this.videoUrlEs

        if (this.form.id !== undefined && this.form.id !== null) {
          // 修改前弹确认框
          this.$confirm({
            title: '确认修改',
            content: '确保轮播图有一个可用状态，是否继续？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
              this.submitLoading = true
              updateBanner(this.form)
                .then(response => {
                  this.$message.success('修改成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            },
            onCancel: () => {
              // 可以不做操作，也可以提示已取消
              this.$message.info('已取消修改', 3)
            }
          })
        } else {
          // 新增直接提交
          this.submitLoading = true
          addBanner(this.form)
            .then(response => {
              this.$message.success('新增成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    }

  }
}
</script>
